const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/8529d84a6961ef3b5ae0a1cc84590c95.jpg"
          alt="El Paso TX cityscape with Franklin Mountains"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>
      
      <div className="relative z-10 w-full max-w-6xl mx-auto px-6 text-center text-white">
        <h1 className="text-5xl md:text-7xl font-bold mb-6 leading-tight">
          El Paso TX Home Buyers
        </h1>
        <p className="text-2xl md:text-3xl mb-4 font-light">
          Real Local Property Buyers
        </p>
        <p className="text-lg md:text-xl max-w-3xl mx-auto mb-8 leading-relaxed">
          Trusted local experts buying homes across El Paso, Texas. Fast cash offers, no repairs needed, close on your timeline.
        </p>
        
        <div className="flex flex-wrap justify-center gap-6 mt-12">
          <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20">
            <div className="text-3xl font-bold mb-1">15+</div>
            <div className="text-sm">Years in El Paso</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20">
            <div className="text-3xl font-bold mb-1">1,200+</div>
            <div className="text-sm">Homes Purchased</div>
          </div>
          <div className="bg-white/10 backdrop-blur-sm px-8 py-4 rounded-lg border border-white/20">
            <div className="text-3xl font-bold mb-1">7 Days</div>
            <div className="text-sm">Average Close Time</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
